import * as $ from "jquery";

export class ShowMoreButton {
    $but: JQuery;
    targetclassname: string;
    removeclassname: string;
    showmorecount: number;

    constructor(
        $but: JQuery,
        targetclassname: string,
        removeclassname: string,
        showmorecount: number,
    ) {
        const self = this;
        this.$but = $but;
        this.targetclassname = targetclassname;
        this.removeclassname = removeclassname;
        this.showmorecount = showmorecount;

        this.updateButton();

        $but.on("click", function () {
            const $available = self.getAvailable();
            const $showlist = $available.slice(0, self.showmorecount);
            $showlist.removeClass(self.removeclassname);
            self.updateButton();
        });
    }

    updateButton() {
        const available = this.getAvailable();
        this.$but.toggle(available.length > 0);
    }

    getAvailable(): JQuery {
        return $(this.targetclassname);
    }
}
